export default "__VITE_ASSET__ebc2ea55__"